module.exports = __webpack_public_path__ + "img/momap.4a41bc5f.png";